module.exports = __webpack_public_path__ + "static/media/Dark Willow.6f53b39c.png";